import Hook from "./snake.lib.hook";
import "intl-tel-input/build/js/utils";
import intlTelInput from "intl-tel-input";
import Trace from "./snake.lib.trace";

Element.prototype.innerLoader = function (active = true, className = "loading") {
    if (active) this.classList.add(className);
    else this.classList.remove(className);
};

export default class Utils {
    static initRepeater = () => {
        const repeaters = document.querySelectorAll("[data-repeater]");

        for (const repeater of repeaters) {
            const data = repeater.dataset;
            const container = repeater.querySelector("#" + data.repeater);
            const repeaterElement = repeater.querySelector("button[data-add='" + data.repeater + "']");

            if (!repeaterElement.dataset.events || !repeaterElement.dataset.events.includes("click")) {
                repeaterElement.addEventListener("click", (e) => {
                    Trace.debug("initRepeater CLICK");

                    const elementCount = container.childElementCount;

                    if (data.limit && elementCount < data.limit) {
                        container.appendChild(repeater.querySelector("template").content.cloneNode(true));

                        container.lastElementChild.classList.add("repeater-item");

                        container.lastElementChild.querySelector("[data-delete='" + data.repeater + "']").addEventListener("click", () => {
                            Hook.publish("_repeaterDelete", {
                                detail: {
                                    repeaterDataReference: data.repeater,
                                    repeaterElementIndex: elementCount,
                                },
                            });
                        });

                        Hook.publish("_repeaterAdded", {
                            detail: {
                                repeaterDataReference: data.repeater,
                                repeaterElementIndex: elementCount,
                            },
                        });
                    }

                    if (elementCount === data.limit - 1) e.currentTarget.classList.add("hidden");
                });

                repeaterElement.dataset.events = "click";
            }
        }
    };

    static initTabs = () => {
        const tabs = document.querySelectorAll("[data-tabs]");

        for (const tab of tabs) {
            tab.addEventListener("click", (e) => {
                const attributes = e.currentTarget.dataset;

                for (const domElm of tabs) {
                    document.getElementsByClassName(domElm.dataset.tabs)[0].classList.add("hidden");
                    domElm.classList.remove("active");
                }

                document.getElementsByClassName(attributes.tabs)[0].classList.remove("hidden");

                e.currentTarget.classList.add("active");
            });
        }
    };

    static modal = (dataAttributeReference, active = true, i18n = {}, confirmCallback = null, dismissCallback = null, style = "default") => {
        const element = document.querySelector("[data-modal='" + dataAttributeReference + "']");
        const elementTitleContainer = element.querySelector(".header");
        const elementContentContainer = element.querySelector(".content");
        const elementDescriptionContainer = element.querySelector(".description");
        const elementConfirmBtn = element.querySelector("[data-confirm]");
        const elementDismissBtn = element.querySelector(".dismiss");

        element.classList.add("style-" + style);

        if (elementTitleContainer && i18n.title) {
            elementTitleContainer.querySelector("span").innerHTML = i18n.title;
            elementTitleContainer.classList.remove("hidden");
        }
        if (elementContentContainer) elementContentContainer.innerHTML = i18n.text ?? "";
        if (elementDescriptionContainer) elementDescriptionContainer.innerHTML = i18n.description ?? "";
        if (elementConfirmBtn) elementConfirmBtn.firstElementChild.innerHTML = i18n.confirmBtn ?? "Confirm";
        if (elementDismissBtn) elementDismissBtn.firstElementChild.innerHTML = i18n.dismissBtn ?? "Dismiss";

        let confirmEventFunction;
        let dismissEventFunction;
        const cleanEventListener = () => {
            if (elementConfirmBtn) elementConfirmBtn.removeEventListener("click", confirmEventFunction);
            if (elementDismissBtn) elementDismissBtn.removeEventListener("click", dismissEventFunction);
        };

        if (active) {
            if (elementConfirmBtn) {
                if (confirmCallback) {
                    confirmEventFunction = () => {
                        cleanEventListener();
                        confirmCallback();
                    };

                    elementConfirmBtn.addEventListener("click", confirmEventFunction);
                } else {
                    elementConfirmBtn.addEventListener("click", () => {
                        element.classList.add("hidden");
                    });
                }
            }

            if (elementDismissBtn) {
                if (dismissCallback) {
                    dismissEventFunction = () => {
                        cleanEventListener();
                        dismissCallback();
                    };

                    elementDismissBtn.addEventListener("click", dismissEventFunction);
                } else {
                    elementDismissBtn.addEventListener("click", () => {
                        element.classList.add("hidden");
                    });
                }
            }

            element.querySelectorAll("[data-close]").forEach((closeAction) => {
                closeAction.addEventListener("click", () => {
                    element.classList.add("hidden");
                });
            });

            element.classList.remove("hidden");
        } else {
            element.classList.add("hidden");
        }
    };

    static spinner = (dataAttributeReference, active = true) => {
        const element = document.querySelector("[data-spinner='" + dataAttributeReference + "']");

        if (active) element.classList.remove("hidden");
        else element.classList.add("hidden");
    };

    static initPhoneNumber = (ref, currentCountry, countries) => {
        const countryCode = countries[currentCountry].code || currentCountry;

        intlTelInput(ref, {
            separateDialCode: true,
            initialCountry: countryCode,
            preferredCountries: [countryCode],
            onlyCountries: Object.keys(countries).map(function (key) {
                return countries[key].countryCode.toLowerCase() === "uk" ? "gb" : countries[key].countryCode.toLowerCase();
            }),
        });
    };

    static setPhoneNumberValue = (ref) => {
        const iti = window.intlTelInputGlobals.getInstance(ref);
        iti.setNumber(ref.value);
    };

    static sleep = (delay) => new Promise((resolve) => setTimeout(resolve, delay));
}
